import { db } from '../firebase/config';
import { collection, getDocs } from 'firebase/firestore';

export const testFirebaseConnection = async () => {
  try {
    console.log('Testing Firebase connection...');
    
    // Try to read from a collection (this will work even if empty)
    const testCollection = collection(db, 'test');
    await getDocs(testCollection);
    
    console.log('✅ Firebase connection successful!');
    return true;
  } catch (error) {
    console.error('❌ Firebase connection failed:', error);
    return false;
  }
};

export const testCategoriesCollection = async (familyId) => {
  try {
    console.log('Testing categories collection for familyId:', familyId);
    
    const categoriesRef = collection(db, `families/${familyId}/categories`);
    const snapshot = await getDocs(categoriesRef);
    
    console.log('Categories found:', snapshot.docs.length);
    snapshot.docs.forEach(doc => {
      console.log('Category:', doc.id, doc.data());
    });
    
    return snapshot.docs.length;
  } catch (error) {
    console.error('Error testing categories:', error);
    return 0;
  }
};
